<template>
    <transition name="loading">
        <div class="loading-progress-bar" v-if="loadingStatus" :class="{loaded: loadedStatus}"></div>
    </transition>
</template>

<script>
    import {mapMutations, mapState} from "vuex";

    export default {
        name: "loading_progress",
        data: () => ({
            loadEndingTimeout: false,
        }),
        methods: {
            ...mapMutations('loading_progress', ['stopLoading']),
        },
        computed: {
            loadingStatus() {
                return this.loading || this.loadEndingTimeout;
            },
            loadedStatus() {
                return this.loaded;
            },
            ...mapState('loading_progress', ['loading', 'loaded'])
        },
        watch: {
            loaded(v) {
                if (v) {
                    clearTimeout(this.loadEndingTimeout);
                    this.loadEndingTimeout = setTimeout(() => {
                        this.loadEndingTimeout = false;
                        this.stopLoading();
                    }, 600)
                }
            }
        },
    }
</script>

<style lang="scss">

    .loading-enter-active, .loading-leave-active {
        transition: transform 250ms ease-out;
    }

    .loading-enter, .loading-leave-to {
        transform: translateY(-110%);
    }

    .loading-progress-bar {
        z-index: 999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;

        height: 3px;

        &::before, &::after {
            content: "";
            position: absolute;
            display: block;
            height: inherit;

            background-color: $blue;

            animation-timing-function: linear;
            animation-fill-mode: forwards;

        }

        &::before {
            @keyframes loaded {
                from {width: 0}
                to {width: 100%}
            }

            animation-name: loading;
            animation-duration: 5000ms;
        }

        &.loaded::after {
            @keyframes loading {
                from {width: 0}
                to {width: 80%}
            }

            animation-name: loaded;
            animation-duration: 500ms;
        }
    }
</style>